import { Auth } from 'aws-amplify';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import request from '../ct-request';

const useUserLogin = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();

  const login = useCallback(async ({ email, password, rememberUser }, { onSuccess, onError }) => {
    setIsLoading(true);
    setError(undefined);
    try {
      dispatch({ type: 'accounts/updateUserNotConfirmed', payload: false });

      const user = await Auth.signIn(email, password);
      const { idToken } = user.signInUserSession;
      const tokenWithCustomerId = idToken.jwtToken;
      localStorage.setItem('access_token', tokenWithCustomerId);

      const anonymousId = localStorage.getItem('anonymousId');
      const loginResponse = await request({
        uri: 'customers/login',
        options: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(anonymousId && { anonymousId }),
          },
          body: JSON.stringify({
            email,
          }),
        },
      });
      localStorage.setItem('showCartMerged', loginResponse?.cartMerged);
      user.attributes.phone_number =
          user.attributes.phone_number &&
          user.attributes.phone_number.replace('+1', '');
      dispatch({ type: 'accounts/setUserProfile', payload: user.attributes });
      dispatch({ type: 'accounts/setUserID', payload: idToken.payload.customerId });
      dispatch({ type: 'accounts/setCustomerId', payload: idToken.payload.customerId });

      if (rememberUser) {
        localStorage.setItem('PUA::Remembered', email);
      } else if (localStorage.getItem('PUA::Remembered')) {
        localStorage.removeItem('PUA::Remembered');
      }

      window.pubSub?.publish('onAccountSignIn', {});
      localStorage.removeItem('createdAccount');

      setIsLoading(false);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      setError(err);
      setIsLoading(false);
      if (onError) {
        onError(err);
      }
    }
  }, [dispatch]);

  return { isLoading, error, login };
};

export default useUserLogin;
